import t from '../../../lib/i18n';
import { getRedirectCode } from '../../../lib/configUtils';
import { LOGIN_PATH } from 'config';
import useConfig from '../../../hooks/useConfig';
import useGTM from "../../../hooks/useGTM";
import { trackFavouritesLoginIntent } from "../../../lib/tracking";

import '../../../styles/components/favourites/login.scss';
import Button, { ButtonLinkTargets } from '../../ui/Button';

const FavouritesLoginLink = () => {
  const { host, rootElement, brand, redirectEnvironment } = useConfig();
  const dispatchGTM = useGTM();
  const redirectCode = getRedirectCode(brand, redirectEnvironment);
  const link = host + LOGIN_PATH + `?redirect=${redirectCode}`;
  const linkTarget = rootElement !== null ? ButtonLinkTargets.TOP : ButtonLinkTargets.SELF;

  function onClick () {
    dispatchGTM(trackFavouritesLoginIntent());
  }

  return (
    <Button
      className="otrl-jp__favourites-login__button"
      link={link}
      linkTarget={linkTarget}
      onClick={onClick}
      text={t("favourites.login.button")}
    />
  );
};

export default FavouritesLoginLink;
